'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSortAlphabeticallyOutline = function TiSortAlphabeticallyOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.4 23.3h4.6l-2.3-4.6z m25.6 0l4-5.3c1.1-1.5 1.3-3.5 0.5-5.2-0.9-1.7-2.6-2.8-4.5-2.8h-10c-2.8 0-5 2.2-5 5 0 1.3 0.5 2.4 1.3 3.3h-0.5c-0.6 0-1.1 0.2-1.6 0.5l-3.1-6c-0.8-1.7-2.5-2.7-4.4-2.7s-3.7 1-4.5 2.7l-6.7 13.3c-0.6 1.2-0.7 2.5-0.2 3.8s1.3 2.3 2.5 2.9c0.7 0.4 1.4 0.5 2.2 0.5 1.9 0 3.6-1 4.5-2.7l0.3-0.6h3.8l0.3 0.6c0.8 1.7 2.5 2.7 4.4 2.7 0.8 0 1.6-0.1 2.3-0.5 0.4-0.2 0.7-0.5 1.1-0.8 0.9 0.9 2 1.3 3.3 1.3h10c2.8 0 5-2.2 5-5s-2.2-5-5-5z m-15.9 6.5c-0.3 0.1-0.5 0.2-0.8 0.2-0.6 0-1.2-0.3-1.5-0.9l-1.2-2.4h-7.9l-1.2 2.4c-0.3 0.6-0.9 0.9-1.5 0.9-0.3 0-0.5-0.1-0.7-0.2-0.9-0.4-1.2-1.4-0.8-2.2l6.7-13.3c0.3-0.6 0.9-0.9 1.5-0.9s1.2 0.3 1.5 0.9l6.6 13.3c0.4 0.8 0.1 1.8-0.7 2.2z m1.7-6.5c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.7 1.6-1.7h1.7c0.9 0 1.7 0.7 1.7 1.7s-0.8 1.6-1.7 1.6h-1.7z m14.2 6.7h-10c-0.6 0-1.2-0.4-1.5-0.9s-0.2-1.3 0.2-1.8l8-10.6h-6.7c-0.9 0-1.7-0.8-1.7-1.7s0.8-1.7 1.7-1.7h10c0.6 0 1.2 0.4 1.5 1s0.2 1.2-0.2 1.7l-8 10.7h6.7c0.9 0 1.7 0.7 1.7 1.6s-0.8 1.7-1.7 1.7z' })
        )
    );
};

exports.default = TiSortAlphabeticallyOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/sort-alphabetically-outline.js
// module id = 3218
// module chunks = 0